<mx-preloader preloaderName="report"></mx-preloader>

@if (isMobile) {
    <h2 class="mob-title statistics-title statistics-icon">
        <prl-label value="label.menu.stats"/>
    </h2>
}

<mat-card>
    <div class="row">
        <mat-form-field id="reportName" class="mxs-input">
            <mat-label>
                <prl-label value="label.stats.reports"/>
            </mat-label>
            <mat-select hideSingleSelectionIndicator="true"
                        [formControl]="selectedReportControl"
                        (selectionChange)="onReportChanged()"
                        required>
                @for (report of reports; track report) {
                    <mat-option [value]="report">{{ report.value }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        <mat-form-field id="campaignName" class="mxs-input">
            <mat-label>
                <prl-label value="label.stats.campaigns"/>
            </mat-label>
            <mat-select hideSingleSelectionIndicator="true"
                        [formControl]="selectedCampaignControl"
                        (selectionChange)="onCampaignChanged()"
                        required>
                @for (campaign of currentCampaigns; track campaign) {
                    <mat-option [value]="campaign">{{ campaign ? campaign.value : 'NONE' }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
    <mat-card-content class="form multiple-columns">
        <mx-dynamic-fields [ngClass]="{'hidden' : !isReportReady || !showFilters}"
                [form]="form"
                [fields]="inputFields"
                class="mx-form-fields">
            @if (showCurrencyTooltip) {
                <ng-template mxFormField="currencyCode" mxFormFieldPlacement="after">
                    <mx-info-tooltip [config]="currencyTooltipConfig"></mx-info-tooltip>
                </ng-template>
            }
        </mx-dynamic-fields>
    </mat-card-content>
    <div class="divider-wrapper" [ngClass]="{'hide' : showFilters}" *ngIf="isReportReady">
        <button mat-icon-button
                class="divider-button"
                type="button"
                (click)="toggleFilters()">
            <i class="material-icons">
                keyboard_arrow_down
            </i>
        </button>
    </div>
    <mat-card-actions>
        <mx-button [buttonModel]="runReportButton"></mx-button>
        <mx-button [buttonModel]="exportReportButton"></mx-button>
        <mx-info-tooltip [config]="exportReportConfig"></mx-info-tooltip>
    </mat-card-actions>
</mat-card>

<mat-card class="table">
    <mx-grid [ngClass]="{'empty' : !isDataReady}"></mx-grid>
</mat-card>


